import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { getClassSectionByProgramPlanId } from '../../Utils/apiServices';
import configContext from '../../Utils/context';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  rootToggle: {
    margin: 8,
    border: `1px solid ${theme.palette.KenColors.lightGray}`,
    borderRadius: 5,
    padding: '6px 24px',
  },
  selectedToggle: {
    backgroundColor: `${theme.palette.KenColors.primary} !important`, //FIXME when migrated from v4 to v5 this needs to be changed
    color: `${theme.palette.KenColors.kenWhite} !important`,
  },
}));

export default function SelectSections(props) {
  const { onChange, value, id, programId, setLoader } = props;
  const classes = useStyles();
  const [classSections, setClassSections] = useState();
  const { handleSnackbarOpen } = React.useContext(configContext);
  const { t } = useTranslation();

  useEffect(() => {
    getClassSectionByProgramPlanId(programId)
      .then((res) => {
        if (res.length > 0) {
          setClassSections((classSec) => ({
            ...classSec,
            [id]: { array: res, programId: programId },
          }));
        } else {
          handleSnackbarOpen('warning', t('messages:No_Sections_Found'));
        }
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        handleSnackbarOpen('warning', t('messages:No_Sections_Found'));
        setLoader(false);
      });
  }, [programId]);

  return (
    <Grid item md={12}>
      {classSections &&
        classSections[id]?.array?.map((elem) => {
          return (
            <ToggleButtonGroup
              value={value}
              onChange={(e, sec) => {
                onChange(e, sec, id, classSections[id]?.programId);
              }}
              classes={{
                groupedHorizontal: classes.toggleGroupedHorizontal,
              }}
            >
              <ToggleButton
                value={`${elem?.Section}`}
                classes={{
                  root: classes.rootToggle,
                  selected: classes.selectedToggle,
                }}
              >
                {elem?.Section}
              </ToggleButton>
            </ToggleButtonGroup>
          );
        })}
    </Grid>
  );
}
